import {
  Activity,
  Crown,
  DollarSign,
  Drum,
  GalleryVerticalEnd,
  Handshake,
  MonitorCog,
  Rss,
  Settings,
  SquareActivity,
} from 'lucide-react'

import { Smartrade } from '@fortem-monorepo/react-ui'

import { type GlobalSidebarMenuItem } from '@/components/GlobalSidebar/GlobalSidebar.types'
import { IMPERSONATE, NOTIFICATIONS } from '@/constants/actions'
import {
  ADMIN_LINKS,
  FEEDS_LINKS,
  FLOW_LINKS,
  FUNDS_LINKS,
  HOME,
  INSTRUMENTS_LINKS,
  MONITORING_LINKS,
  OPERATIONS_LINKS,
  PM_LINKS,
  SALES_LINKS,
  SMARTRADE_LINKS,
  TRADING_LINKS,
} from '@/constants/links'
import { createPopover } from '@/index'

export const headerMenu: GlobalSidebarMenuItem[] = [HOME, NOTIFICATIONS]

export const smartradeMenu: GlobalSidebarMenuItem[] = [
  createPopover({
    label: 'Smartrade',
    icon: Smartrade,
    children: SMARTRADE_LINKS,
  }),
]

export const mainMenu: GlobalSidebarMenuItem[] = [
  createPopover({
    label: 'Admin',
    icon: Crown,
    children: ADMIN_LINKS,
  }),
  createPopover({
    label: 'Data Presence',
    icon: Rss,
    children: FEEDS_LINKS,
  }),
  createPopover({
    label: 'Operations',
    icon: Settings,
    children: OPERATIONS_LINKS,
  }),
  createPopover({
    label: 'Trading',
    icon: Handshake,
    children: TRADING_LINKS,
  }),
  createPopover({
    label: 'Funds',
    icon: GalleryVerticalEnd,
    children: FUNDS_LINKS,
  }),
  createPopover({
    label: 'Flow',
    icon: Activity,
    children: FLOW_LINKS,
  }),
  createPopover({
    label: 'Sales',
    icon: DollarSign,
    children: SALES_LINKS,
  }),
  createPopover({
    label: 'PM',
    icon: SquareActivity,
    children: PM_LINKS,
  }),
  createPopover({
    label: 'Instruments',
    icon: Drum,
    children: INSTRUMENTS_LINKS,
  }),
]

export const footerMenu: GlobalSidebarMenuItem[] = [
  // CHANGELOG,
  createPopover({
    label: 'Monitoring',
    icon: MonitorCog,
    children: MONITORING_LINKS,
  }),
  IMPERSONATE,
]
